import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ModalProvider {

  private modalState: string;

  constructor() {}

  getState() {
    return this.modalState;
  }

  setState( state: string ) {
    this.modalState = state;
  }

}
